<template>
  <div class="animated fadeIn">


  <ConfirmationModal
    v-if="productEditRenew"
    v-bind:show="modalNewCard"
    :title="confirmTitle"
    confirmText='Aceptar'
    cancelText='Cancelar'
    @cancel="resetRenewal"
    @confirm="updateRenewal"
  >

  <!-- {{ productEditRenew.total_amount.toFixed(2)}} €  -->
    <p v-if="productEditRenew && !productEditRenew.renewal">
      El plan se renovará automáticamente y se cobrará en la tarjeta de crédito el importe correspondiente
      <span v-if="productEditRenew.next_payment_date"> el día {{ formatDateShort(productEditRenew.next_payment_date) }}, </span>
      un día antes que vez venza el periodo actual de contratación el {{ formatDateShort(productEditRenew.end_datetime) }}.
      <!-- <span v-if="productEditRenew.next_payment_date"> el {{ formatDateShort(productEditRenew.next_payment_date) }}</span>
      <span v-else> el {{ formatDateShort(productEditRenew.end_datetime) }}</span>. -->
    </p>

    <p v-else>
      El plan no se renovará automáticamente una vez venza el periodo actual de contratación el {{ formatDateShort(productEditRenew.end_datetime) }}
      <!-- <span v-if="productEditRenew.next_payment_date"> el {{ formatDateShort(productEditRenew.next_payment_date) }}</span>
      <span v-else> el {{ formatDateShort(productEditRenew.end_datetime) }}</span> -->
    </p>

    <small class="text-primary">* Una vez completado el proceso estará activo su plan actualizado</small>

  </ConfirmationModal>

  <CRow >
    <!-- class="alquileres" -->
    <CCol sm="12">

      <h2 class="mb-4">
        <strong>Mis Planes</strong>
      </h2>

      <p class="main-section-subtitle">
        Alquiler de plazas de garaje exclusivas para motocicletas con taquillas incluidas en el centro de tu ciudad.
        Parking por horas o meses solo para motos. Taquillas individuales. Vídeo vigilancia 24h. Acceso mediante pin.
      </p>


      <CTabs variant="pills" justified class="mb-4"
        add-nav-classes="mb-4"
        :active-tab.sync="activeTab">

          <CTab active>
            <template slot="title">
              Activos
              <CSpinner v-if="loadingActive" size="sm" color="dark"/>
              <CBadge v-else color="success" class="ml-auto">{{ productActiveList.length}}</CBadge>
            </template>

            <PlansFilter
              :element="'Productos'"
              @getData="getActiveProduct($event)"
            />

            <SpinnerCircle :show="loadingActive" />
            <div v-if="!loadingActive">
              <div v-if="productActiveList && !productActiveList.length" class="alert alert-warning animated zoomIn faster">
                <p>Todavía no dispones de ningún plan en activo actualmente. Vaya a
                  <router-link to="/parkings"> <strong>Parkings</strong></router-link>  para iniciar un proceso de contratación
                   o comprueba los planes pendientes <a @click="activeTab = 1" class="pointer text-primary"> <strong>Activo (próximamente)</strong></a></p>
              </div>
              <CRow class="parking-list">
                <product-card
                  v-for="(item, index) in visibleActiveList" :key="index"
                  v-bind:item="item"
                  :loading="loadingActive"
                  cardClasses="col-lg-6 col-md-6 col-sm-4 col-12 h-100 mb-3"
                  @toggle-renewal="toggleRenewal($event)"
                  @showInvoiceAlert="showStayingBill = true"
                />
              </CRow>
              <div v-if="hasMoreActive" class="text-center mt-3 mb-4">
                <CButton color="outline-primary" @click="loadMoreActive" class="mr-2">
                  Cargar más ({{ productActiveList.length - activeVisibleCount }} restantes)
                </CButton>
                <CButton color="link" @click="showAllActive">
                  Ver todos
                </CButton>
              </div>
            </div>
          </CTab>

          <CTab>
            <template slot="title">
              Activos Próximamente
              <CSpinner v-if="loadingNotActive" size="sm" color="dark"/>
              <CBadge v-else color="success" class="ml-auto">{{ productNotActiveList.length}}</CBadge>
            </template>

            <PlansFilter
              :element="'Planes'"
              :showFilter="filterActive"
              @getData="getNotActiveProduct($event)"
            />

            <SpinnerCircle :show="loadingNotActive" />
            <div v-if="!loadingNotActive">

              <div v-if="productNotActiveList && !productNotActiveList.length" class="alert alert-warning animated zoomIn faster">
                <p>Todavía no dispones de ningún plan pendiente de iniciar. Vaya a
                  <router-link to="/parkings"> <strong>Parkings</strong></router-link>  para iniciar un proceso de contratación</p>
              </div>

              <CRow class="parking-list">
                <product-card
                  v-for="(item, index) in visibleNotActiveList" :key="index"
                  v-bind:item="item"
                  :loading="loadingNotActive"
                  cardClasses="col-lg-6 col-md-6 col-sm-4 col-12 h-100 mb-3"
                  @toggle-renewal="toggleRenewal"
                  @showInvoiceAlert="showStayingBill = true"
                />
              </CRow>
              <div v-if="hasMoreNotActive" class="text-center mt-3 mb-4">
                <CButton color="outline-primary" @click="loadMoreNotActive" class="mr-2">
                  Cargar más ({{ productNotActiveList.length - notActiveVisibleCount }} restantes)
                </CButton>
                <CButton color="link" @click="showAllNotActive">
                  Ver todos
                </CButton>
              </div>
            </div>
          </CTab>


          <CTab title="Finalizado">
            <template slot="title">
              Finalizados
              <CSpinner v-if="loadingFinished" size="sm" color="dark"/>
              <CBadge v-else color="success" class="ml-auto">{{ productFinishedList.length}}</CBadge>
            </template>

            <PlansFilter
              :element="'Productos'"
              @getData="getFinishedProduct($event)"
            />

            <SpinnerCircle :show="loadingFinished" />

            <div v-if="!loadingFinished">
              <div v-if="productFinishedList && !productFinishedList.length" class="alert alert-warning animated zoomIn faster">
                <p>No hay ningún plan finalizado.</p>
              </div>

              <CRow class="parking-list">
                <product-card
                  v-for="(item, index) in visibleFinishedList" :key="index"
                  v-bind:item="item"
                  :loading="loadingFinished"
                  cardClasses="col-lg-6 col-md-12 col-sm-12 col-12 h-100 mb-3"
                  @toggle-renewal="updateRenewal"
                  @showInvoiceAlert="showStayingBill = true"
                />
              </CRow>
              <div v-if="hasMoreFinished" class="text-center mt-3 mb-4">
                <CButton color="outline-primary" @click="loadMoreFinished" class="mr-2">
                  Cargar más ({{ productFinishedList.length - finishedVisibleCount }} restantes)
                </CButton>
                <CButton color="link" @click="showAllFinished">
                  Ver todos
                </CButton>
              </div>
            </div>

          </CTab>

          <!-- <CTab>
            <template slot="title">
              Cancelado <CBadge color="success" class="ml-auto">{{ productCanceledList.length}}</CBadge>
            </template>

            <PlansFilter
              :element="'Productos'"
              @getData="getFinishedProduct($event)"
            />

            <SpinnerCircle :show="loadingCanceled" />

            <div v-if="!loadingCanceled">
              <div
                v-if="productCanceledList && !productCanceledList.length"
                class="alert alert-warning animated zoomIn faster"
              >
                <p>No hay ningún {{ elemento.toLowerCase() }} cancelado. Vaya a
                  <router-link to="/parkings"> <strong>Parkings</strong></router-link>  para iniciar un proceso de contratación</p>
              </div>
              <div v-else>
                <PlansFilter
                  :element="'Productos'"
                />
              </div>
            </div>

          </CTab> -->

      </CTabs>

    </CCol>
  </CRow>

    <StayingBillModal
      :showModal="showStayingBill"
      @update:showModal="showStayingBill=$event"
    />

    <toast ref="toast"></toast>
  </div>
</template>


<script>

// import { fetchOneClient, updateClient } from '@/app/views/clientes/shared/services';
// import { getLoggedClient } from '@/app/views/auth/shared/services';

import { formatDateShort } from  '@/app/shared/utils/utils';

import {
  fetchAllProductsActive, fetchAllProductsFinished, fetchAllProductsNotActive, updateProduct,
  fetchAllProductsActive2, fetchAllProductsFinished2, fetchAllProductsNotActive2
} from '@/app/shared/global/services/product-service';

import ProductCard from '@/app/views/clientes/shared/components/ProductCard'
import PlansFilter from '@/components/filtros/PlansFilter';
import StayingBillModal from '../../shared/components/modals/StayingBillModal';




export default {
  name: "ClientProducts",
  components: {
      ProductCard,
      PlansFilter,
      StayingBillModal
    },
  data() {
    return {
      userLogged: null,
      elemento: "Plan",
      message: null,

      productActiveList: [],
      productNotActiveList: [],
      productFinishedList: [],
      productCanceledList: [],

      loadingActive: false,
      loadingNotActive: false,
      loadingFinished: false,
      loadingCanceled: false,

      activeTab: 0,
      loading: true,
      filterActive: false,
      modalNewCard: false,
      productEditRenew: null,
      formatDateShort: formatDateShort,
      showStayingBill: false,

      // Pagination
      pageSize: 6,
      activeVisibleCount: 6,
      notActiveVisibleCount: 6,
      finishedVisibleCount: 6,
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.expired) {
      this.$refs.toast.showToast('La sesión ha caducado. Por favor, inicie sesión de nuevo.', null,"error","5000");
    }
  },
  created() {
    // this.getClientLogged();

    this.getActiveProduct();
    this.getFinishedProduct();
    this.getNotActiveProduct();
  },
  computed: {
    confirmTitle() {
      return this.productEditRenew && this.productEditRenew.renewal ?
      'Activar renovación automática' :
      'Anular renovación automática'
    },
    visibleActiveList() {
      return this.productActiveList.slice(0, this.activeVisibleCount);
    },
    visibleNotActiveList() {
      return this.productNotActiveList.slice(0, this.notActiveVisibleCount);
    },
    visibleFinishedList() {
      return this.productFinishedList.slice(0, this.finishedVisibleCount);
    },
    hasMoreActive() {
      return this.productActiveList.length > this.activeVisibleCount;
    },
    hasMoreNotActive() {
      return this.productNotActiveList.length > this.notActiveVisibleCount;
    },
    hasMoreFinished() {
      return this.productFinishedList.length > this.finishedVisibleCount;
    }
  },

  methods: {
    loadMoreActive() {
      this.activeVisibleCount += this.pageSize;
    },
    loadMoreNotActive() {
      this.notActiveVisibleCount += this.pageSize;
    },
    loadMoreFinished() {
      this.finishedVisibleCount += this.pageSize;
    },
    showAllActive() {
      this.activeVisibleCount = this.productActiveList.length;
    },
    showAllNotActive() {
      this.notActiveVisibleCount = this.productNotActiveList.length;
    },
    showAllFinished() {
      this.finishedVisibleCount = this.productFinishedList.length;
    },

    async getActiveProduct(filtro='') {

      const errorMessage = 'Se ha producido un error al obtener los planes.';
      this.filterActive = filtro ? true : false;
      this.activeVisibleCount = this.pageSize;

      try {
        this.loadingActive = true;

        let resp = await fetchAllProductsActive(null, filtro);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(  `${errorMessage} ${resp?.message} `, null, "error", "5000");
          this.loadingActive = false;
          return
        }

        this.productActiveList = resp.data;

        this.loadingActive = false;
      }catch(e) {
        console.log(e);
        this.$refs.toast.showToast(  `${errorMessage}`, null, "error", "5000");
        this.loadingActive = false;
      }
    },

    async getNotActiveProduct(filtro='') {

      const errorMessage = 'Se ha producido un error al obtener los planes.';
      this.filterActive = filtro ? true : false;
      this.notActiveVisibleCount = this.pageSize;

      try {
        this.loadingNotActive = true;

        let resp = await fetchAllProductsNotActive(null, filtro);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(  `${errorMessage} ${resp.data.message} `, null, "error", "5000");
          this.loadingNotActive = false;
          return
        }

        this.productNotActiveList = resp.data;

        this.loadingNotActive = false;
      }catch(e) {
        console.log(e);
        this.$refs.toast.showToast( `${errorMessage}`, null, "error", "5000");
        this.loadingNotActive = false;
      }

    },

    async getFinishedProduct(filtro='') {

      const errorMessage = 'Se ha producido un error al obtener los planes.';
      this.filterActive = filtro ? true : false;
      this.finishedVisibleCount = this.pageSize;

      try {

        this.loadingFinished = true;

        let resp = await fetchAllProductsFinished(null, filtro);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast( `${errorMessage} ${resp?.message} `, null, "error", "5000");
          this.loadingActive = false;
          return
        }

        this.productFinishedList = resp.data;

        this.loadingFinished = false;

      } catch(e) {
        console.log(e);
        this.$refs.toast.showToast(  `${errorMessage}`, null, "error", "5000");
        this.loadingFinished = false;
      }

    },

    toggleRenewal(product) {
      /*
        next_payment_date: "2021-03-30"
        renewal: true
        renewal_limit_days: 1
        total_amount: 89
      */

      this.productEditRenew = product
      this.modalNewCard = true
    },

    resetRenewal() {

      this.modalNewCard = false;

      if (this.productEditRenew.status == "FINISHED") {
        this.updateProductData(this.productEditRenew)
      } else if (["FREE", "RESERVED", "OCCUPIED"].includes(this.productEditRenew.status)) {
        this.updateProductData(this.productEditRenew)
      } else if (this.productEditRenew.status == "CANCELLED") {

      }
      else if (this.productEditRenew.status == "NOT_ACTIVE") {
        this.updateProductData(this.productEditRenew)
      }
    },

    updateRenewal(item) {

      this.modalNewCard = false

      // product_type: "prepago"
      // status: "FINISHED"
      // renewal
      // id
      if (this.productEditRenew.status == "FINISHED") {

        // this.productFinishedList[this.productFinishedList.findIndex( cl => cl.id === this.productEditRenew.id)].renewal = this.productEditRenew.renewal;
        this.$refs.toast.showToast( "Plan finalizado, no es posible actualizar", null,"warn","5000");
        return

      // } else if (["FREE", "RESERVED", "OCCUPIED"].includes(this.productEditRenew.status)) {
      //   let backUpProducts = this.productActiveList
      //   backUpProducts[this.productActiveList.findIndex( cl => cl.id === this.productEditRenew.id)].renewal = this.productEditRenew.renewal

      } else if (this.productEditRenew.status == "CANCELLED") {
        this.$refs.toast.showToast( "Plan cancelado, no es posible actualizar", null,"error","2000");
        return

      }
      // else if (this.productEditRenew.status == "NOT_ACTIVE") {
      //   this.productNotActiveList[this.productNotActiveList.findIndex( cl => cl.id === this.productEditRenew.id)].renewal = this.productEditRenew.renewal;

      // }

      // TODO: check ocupación. Confirmar

      this.updateOneProduct(this.productEditRenew)

    },
    updateProductData(data) {
      let backUpData = []

      if (["FREE", "RESERVED", "OCCUPIED"].includes(data.status)) {
        backUpData = [...this.productActiveList]
        backUpData[this.productActiveList.findIndex( cl => cl.id === this.productEditRenew.id)].renewal = data.renewal

        this.productActiveList = []
        this.$nextTick(() => this.productActiveList = [...backUpData])

      }

      if (data.status === "NOT_ACTIVE") {
        backUpData = [...this.productNotActiveList]
        backUpData[this.productNotActiveList.findIndex( cl => cl.id === this.productEditRenew.id)].renewal = data.renewal

        this.productNotActiveList = []
        this.$nextTick(() => this.productNotActiveList = [...backUpData])

      }
    },
    setLoadData(value){
      this.loadingActive = value;
      this.loadingNotActive = value;
    },

    async updateOneProduct(data) {
      const errorMessage = 'Se ha producido un error al actualizar la renovación.';

      try {

        this.setLoadData(true);

        let resp = await updateProduct(data);

        if (resp.status !== 'success') {
          this.setLoadData(false);

          if (resp.status == 'warn') {
            this.$refs.toast.showToast( `${resp.message} `, null, "warn", "5000");
            return
          }
          this.$refs.toast.showToast(`${errorMessage}`, null, "error", "5000");
          return
        }
        data.renewal = !data.renewal
        this.updateProductData(data) // * Update v-for DOM data without API call
        this.$refs.toast.showToast( "Plan actualizado", null,"success","2000");
        this.setLoadData(false);

      } catch(e) {
        console.log(e);
        this.$refs.toast.showToast( `${errorMessage}`, null, "error", "5000");
        this.setLoadData(false);
      }

    }



  }
};
</script>

<style lang="scss" scoped>
</style>
